import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcelWithoutDisplayNone,
  DownloadDataFile,
  FilterJsonExactlyMatching,
  formateDate,
  formateDateWithTime,
  getDateMinusMonths,
  getEndOfMonth,
  getEndPreviousMonth,
  getStartOfMonth,
  getStartOfPreviousMonth,
  getToday,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import MultiSelectionDropdown from "../App/MultiSelectionDropdown";
import LockUnlock from "../App/LockUnlock";
import { showErrorMessage, showSuccessMessage } from "../Shared/Toast";

function OrderInvoice() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const SelectedJobID: any = searchParams.get("j");

  const [isAnimation, setIsAnimation] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [FilterObjectObject, setFilterObjectObject] = useState<any>({
    StartDate: getDateMinusMonths(1),
    EndDate: getToday(),
    UserName: "",
    Email: "",
    JobID: "",
    InvoiceNumber: "",
    InvoiceType: 100,
    Status: 0,
    Month: 3,
  });
  const [StatusStatus, setStatusStatus] = useState<any>([]);
  const [CampaignFilterList, setCampaignFilterList] = useState<any>([]);
  const [Totals, setTotals] = useState<any>({});

  const [EditObject, setEditObject] = useState<any>({});
  const [editModal, seteditModal] = useState(false);

  const [showModal, setshowModal] = useState(false);
  const [confirmationModalObject, setConfirmationModalObject] = useState({
    PID: "",
    Text: "",
    ToolTip: "",
    ConfirmText: "",
    Status: 0,
    Notes: "",
    Refund: 0,
    RemainingAmount: 0,
  });

  useEffect(() => {
    GetInitialFiltersData();
    // GetCampaignFilterList();
  }, []);

  useEffect(() => {
    if (StatusStatus && StatusStatus.length > 0) ClearFilter(1);
  }, [StatusStatus]);

  useEffect(() => {
    let fromDateStr = "";
    let toDateStr = "";
    if (FilterObjectObject.Month == 1) {
      fromDateStr = getStartOfMonth();
      toDateStr = getEndOfMonth();
    } else if (FilterObjectObject.Month == 2) {
      fromDateStr = getStartOfPreviousMonth();
      toDateStr = getEndPreviousMonth();
    } else if (FilterObjectObject.Month == 3) {
      fromDateStr = getDateMinusMonths(1);
      toDateStr = getToday();
    } else if (FilterObjectObject.Month == 4) {
      fromDateStr = getDateMinusMonths(3);
      toDateStr = getToday();
    }

    setFilterObjectObject((prevState: any) => ({
      ...prevState,
      StartDate: fromDateStr,
      EndDate: toDateStr,
    }));
  }, [FilterObjectObject.Month]);

  function GetInitialFiltersData() {
    let object = {} as any;
    object.Days = -10;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/SiteUser/GetStartAndEndDataAndListsDataForCamControl",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          setStatusStatus(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ClearFilter(IsFirst: any) {
    FilterObjectObject.InvoiceType = 100;
    FilterObjectObject.Status = -1;
    if (SelectedJobID && SelectedJobID != "" && IsFirst == 1) {
      FilterObjectObject.JobID = SelectedJobID;
      FilterObjectObject.StartDate = "";
      FilterObjectObject.EndDate = "";
    } else {
      FilterObjectObject.StartDate = getDateMinusMonths(1);
      FilterObjectObject.EndDate = getToday();
      FilterObjectObject.JobID = "";
    }
    FilterObjectObject.UserName = "";
    FilterObjectObject.Email = "";
    FilterObjectObject.InvoiceNumber = "";
    FilterObjectObject.Month = 3;
    LoadInvoicesData();
  }

  function LoadInvoicesData() {
    setIsAnimation(true);
    let data = {} as any;
    data.StartDate = FilterObjectObject.StartDate;
    data.EndDate = FilterObjectObject.EndDate;
    data.InvoiceType = FilterObjectObject.InvoiceType;
    data.Status = FilterObjectObject.Status;
    data.UserName = FilterObjectObject.UserName;
    data.Email = FilterObjectObject.Email;
    data.InvoiceNumber = FilterObjectObject.InvoiceNumber;
    data.JobID = FilterObjectObject.JobID;
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/LoadInvoicesDataAdmin", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function updateOrderAdminData(
    type: any,
    pid: string,
    colname: any,
    colvalue: any,
    colvalue2: any,
    colvalue3: any,
    colvalue4: any,
  ) {
    let object = {} as any;
    object.type = type;
    object.pid = pid;
    object.colname = colname;
    object.colvalue = colvalue;
    object.colvalue2 = colvalue2;
    object.colvalue3 = colvalue3;
    object.colvalue4 = colvalue4;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/UpdateOrderAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          LoadInvoicesData();
          setshowModal(false);
        } else {
          console.log("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function SaveInvoiceData(
    Type: any,
    Index: any,
    PTPaymentIndividualInvoiceID: any,
  ) {
    let data = {} as any;
    data.Type = Type;
    data.PTPaymentIndividualInvoiceID = PTPaymentIndividualInvoiceID;
    data.Name = thisGridListData[Index].Name;
    data.EmailAddress = thisGridListData[Index].EmailAddress;
    data.CompanyName = thisGridListData[Index].CompanyName;
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/UpdateInvoicesDataAdmin", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0][0];
          let l_data = [...thisGridListData];
          l_data[Index].PDFURL = l_oResponse.PDFURL;

          setThisGridListData(l_data);
          thisGridListDataRef.current = l_data;
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function SaveEditedInvoiceData() {
    var data: any = {} as any;
    data.PTPaymentIndividualInvoiceID = EditObject.PTPaymentIndividualInvoiceID;
    data.CompanyName = EditObject.CompanyName;
    data.Name = EditObject.Name;
    data.EmailAddress = EditObject.EmailAddress;
    data.ZipCode = EditObject.ZipCode;
    data.AddressLine1 = EditObject.AddressLine1;
    data.AddressLine2 = EditObject.AddressLine2;
    data.CompanyNumber = EditObject.CompanyNumber;
    data.VATNumber = EditObject.VATNumber;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/SiteUser/UpdateEditedInvoicesDataAdmin",
        data,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
        }
        seteditModal(false);
        LoadInvoicesData();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function SetTotal() {
    var TotalReceived = 0;
    var TotalRefunded = 0;
    var VATCollection = 0;
    var VATRefunded = 0;
    for (var i = 0; i < thisGridListData.length; i++) {
      if (thisGridListData[i].ObjectType == 1) {
        TotalReceived += thisGridListData[i].TotalAmount;
        if (thisGridListData[i].TotalAmount > 0)
          VATCollection += thisGridListData[i].VATAmount;
      } else if (thisGridListData[i].ObjectType == 2) {
        TotalRefunded += thisGridListData[i].TotalAmount;
        VATRefunded += thisGridListData[i].VATAmount;
      }
    }
    let thistotal = {} as any;
    thistotal.TotalReceived = TotalReceived?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    thistotal.TotalRefunded = TotalRefunded?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    thistotal.VATCollection = VATCollection?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    thistotal.VATRefunded = VATRefunded?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    setTotals(thistotal);
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "InvoiceNumber")) {
        (
          document.getElementById(
            "imgSort" + "InvoiceNumber",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  function updateSelectedPIDForParent(type: any, value: any, name: any) {
    if (type == 1) {
      FilterObjectObject.CampaignCode = value;
      setFilterObjectObject((prevState: any) => ({
        ...prevState,
        CampaignCode: value,
      }));
    }
  }

  useEffect(() => {
    if (thisGridListData && thisGridListData.length > 0) SetTotal();
  }, [thisGridListData]);

  function updatedata(index: number, value: any, colname: any) {
    let tempArray = [...thisGridListData];
    tempArray[index][colname] = value;
    setThisGridListData(tempArray);
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      <>
        <div className="grid-d fr-1111 flex-gap10">
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Month</span>
            <select
              value={FilterObjectObject.Month}
              onChange={(e) => {
                FilterObjectObject.Month = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  Month: e.target.value,
                }));
              }}
              className="input-field w-100"
            >
              <option value="1">This Month</option>
              <option value="2">Last Month</option>
              <option value="3">Last 30 Days</option>
              <option value="4">Last 90 Days</option>
            </select>
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Start Date</span>
            <input
              type="Date"
              className="input-field w-100"
              value={moment(FilterObjectObject.StartDate).format("YYYY-MM-DD")}
              onChange={(e) => {
                FilterObjectObject.StartDate = moment(e.target.value).format(
                  "YYYY-MM-DD",
                );
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  StartDate: moment(e.target.value).format("YYYY-MM-DD"),
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">End Date</span>
            <input
              type="Date"
              className="input-field w-100"
              value={moment(FilterObjectObject.EndDate).format("YYYY-MM-DD")}
              onChange={(e) => {
                FilterObjectObject.EndDate = moment(e.target.value).format(
                  "YYYY-MM-DD",
                );
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  EndDate: moment(e.target.value).format("YYYY-MM-DD"),
                }));
              }}
            />
          </div>

          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Customer Name</span>
            <input
              type="text"
              className="input-field w-100"
              value={FilterObjectObject.UserName}
              onChange={(e) => {
                FilterObjectObject.UserName = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  UserName: e.target.value,
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">
              Customer Email
            </span>
            <input
              type="text"
              className="input-field w-100"
              value={FilterObjectObject.Email}
              onChange={(e) => {
                FilterObjectObject.Email = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  Email: e.target.value,
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Order Number</span>
            <input
              type="text"
              className="input-field w-100"
              value={FilterObjectObject.JobID}
              onChange={(e) => {
                FilterObjectObject.JobID = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  JobID: e.target.value,
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">
              Invoice Number
            </span>
            <input
              type="text"
              className="input-field w-100"
              value={FilterObjectObject.InvoiceNumber}
              onChange={(e) => {
                FilterObjectObject.InvoiceNumber = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  InvoiceNumber: e.target.value,
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Type</span>
            <select
              value={FilterObjectObject.InvoiceType}
              onChange={(e) => {
                FilterObjectObject.InvoiceType = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  InvoiceType: e.target.value,
                }));
              }}
              className="input-field w-100"
            >
              <option value="100">All</option>
              <option value="101">Payment Invoice</option>
              <option value="102">Refund Invoice</option>
            </select>
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Status</span>
            <select
              value={FilterObjectObject.Status}
              onChange={(e) => {
                FilterObjectObject.Status = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  Status: e.target.value,
                }));
              }}
              className="input-field w-100"
            >
              <option value="-1">All</option>
              <option value="2">Paid</option>
              <option value="1">Pending</option>
            </select>
          </div>
        </div>
        <div className="flex-daj btn-start flex-gap10 mt-10">
          <a
            className="btn-primary flex-daj"
            onClick={() => LoadInvoicesData()}
          >
            Apply Filter
          </a>
          <a className="btn-primary flex-daj" onClick={() => ClearFilter(0)}>
            Clear Filter
          </a>
        </div>
        <div className="grid-d fr-1111 flex-gap10 mt-20">
          <div className="data-boxes">
            <span className="data-txt">Total Amount Received</span>
            <span>£{Totals.TotalReceived}</span>
          </div>
          <div className="data-boxes">
            <span className="data-txt">Total Amount Refunded</span>
            <span>£{Totals.TotalRefunded}</span>
          </div>
          <div className="data-boxes">
            <span className="data-txt">Total VAT Collection</span>
            <span>£{Totals.VATCollection}</span>
          </div>
          <div className="data-boxes">
            <span className="data-txt">Total VAT Refunded</span>
            <span>£{Totals.VATRefunded}</span>
          </div>
        </div>
        <div className="flex-da justify-end mt-10 mb-10 flex-gap10">
          <div className="flex-daj flex-gap10">
            <a
              className="link-btn btn-link-m"
              onClick={() => ClearAllFilters()}
            >
              Clear All Filters
            </a>
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcelWithoutDisplayNone(
                  "tblcampaigndata",
                  "Invoices Data " + moment().format("DD-MM-YY HH-mm-ss"),
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
            {/* <LockUnlock locked={isLocked} setLocked={setIsLocked}></LockUnlock> */}
          </div>{" "}
        </div>
        <div className="flow-auto-lg2">
          <table className="reuse-table">
            <thead>
              <tr>
                <th>Action</th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Dated
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "CreationTimestamp")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() =>
                          LoadWithSelectedSort("CreationTimestamp")
                        }
                        title={"Sort By Dated"}
                      >
                        <span id={"imgSort" + "CreationTimestamp"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Invoice Number
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "InvoiceNumber")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("InvoiceNumber")}
                        title={"Sort By InvoiceNumber"}
                      >
                        <span id={"imgSort" + "InvoiceNumber"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Order Number
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "OrderNumber")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("OrderNumber")}
                        title={"Sort By Order Number"}
                      >
                        <span id={"imgSort" + "OrderNumber"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>Customer Name</th>
                <th>Customer Email</th>
                <th>Type</th>
                <th>Status</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <tr>
                        <td className="text-center">
                          <div className="flex-daj gap-10">
                            {item.RefundPayment == 1 && (
                              <a
                                title={item.RefundPaymentToolTip}
                                onClick={() => {
                                  setConfirmationModalObject({
                                    PID: item.ObjectID,
                                    Text: item.RefundPaymentText,
                                    ToolTip: item.RefundPaymentToolTip,
                                    ConfirmText: item.RefundPaymentConfirmText,
                                    Status: item.RefundPaymentStatus,
                                    Notes: item.Notes,
                                    Refund: 1,
                                    RemainingAmount: item.RemainingAmount,
                                  });
                                  setshowModal(true);
                                }}
                              >
                                <img
                                  src="images/pound.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                            )}
                            {item.ManualRefundPayment == 1 && (
                              <a
                                title={item.ManualRefundPaymentToolTip}
                                onClick={() => {
                                  setConfirmationModalObject({
                                    PID: item.ObjectID,
                                    Text: item.ManualRefundPaymentText,
                                    ToolTip: item.ManualRefundPaymentToolTip,
                                    ConfirmText:
                                      item.ManualRefundPaymentConfirmText,
                                    Status: item.ManualRefundPaymentStatus,
                                    Notes: item.Notes,
                                    Refund: 2,
                                    RemainingAmount: item.RemainingAmount,
                                  });
                                  setshowModal(true);
                                }}
                              >
                                <img
                                  src="images/RefundPayment.svg"
                                  width="22px"
                                  height="22px"
                                  alt="Edit"
                                />
                              </a>
                            )}
                            {item.PDFURL != "" && (
                              <a
                                href={item.PDFURL}
                                target="_blank"
                                title="Download Invoice PDF"
                              >
                                <img
                                  src="images/download-t.svg"
                                  width="18px"
                                  height="18px"
                                  alt="download"
                                />
                              </a>
                            )}
                          </div>
                        </td>
                        <td>{formateDateWithTime(item.CreationTimestamp)}</td>
                        <td>
                          <a
                            target="_blank"
                            href={item.PDFURL}
                            title="Download Invoice PDF"
                          >
                            {" "}
                            {item.InvoiceNumber}
                          </a>
                        </td>
                        <td>{item.OrderNumber}</td>
                        <td className="">{item.CustomerName}</td>
                        <td className="">{item.EmailAddress}</td>
                        <td>{item.InvoiceType}</td>
                        <td>{item.StatusText}</td>
                        {item.ObjectType == 1 && (
                          <td className="text-right">
                            £
                            {item.TotalAmount?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                        )}
                        {item.ObjectType == 2 && (
                          <td className="text-right c-red">
                            -£
                            {item.TotalAmount?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                        )}
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </>

      <table className="reuse-table no-display" id="tblcampaigndata">
        <thead>
          <tr>
            <th>Dated</th>
            <th>Invoice Number</th>
            <th>Customer Name</th>
            <th>Customer Email</th>
            <th>Type</th>
            <th>Status</th>
            <th>Payment Type</th>
            <th>Net Total (£)</th>
            <th>VAT (£)</th>
            <th>Gross Total (£)</th>
            <th>Refund Against Invoice</th>
            <th>PCN (No VAT) (£)</th>
          </tr>
        </thead>

        <tbody>
          {thisGridListData &&
            thisGridListData.map((item: any, index: any) => (
              <React.Fragment key={index}>
                {!item.IsExcluded && (
                  <tr key={index}>
                    <td>
                      {moment(item.CreationTimestamp).format("DD/MM/YYYY")}
                    </td>

                    <td>{item.InvoiceNumber}</td>
                    <td>{item.CustomerName}</td>
                    <td>{item.EmailAddress}</td>
                    <td>{item.InvoiceType}</td>
                    <td>{item.StatusText}</td>
                    <td>{item.PaymentMode}</td>

                    {item.Status == 2 ? (
                      item.ObjectType == 1 ? (
                        <>
                          <td>
                            {(item.TotalAmount - item.VATAmount).toFixed(2)}
                          </td>
                          <td>{item.VATAmount.toFixed(2)}</td>
                          <td>{item.TotalAmount.toFixed(2)}</td>
                        </>
                      ) : (
                        <>
                          <td>
                            -{(item.TotalAmount - item.VATAmount).toFixed(2)}
                          </td>
                          <td>-{item.VATAmount.toFixed(2)}</td>
                          <td>-{item.TotalAmount.toFixed(2)}</td>
                        </>
                      )
                    ) : (
                      <>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </>
                    )}

                    <td>{item.ParentInvoiceNumber}</td>
                    <td>{item.PCN}</td>
                  </tr>
                )}
              </React.Fragment>
            ))}
        </tbody>
      </table>

      {editModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup">
              <div className="help-head flex-da justify-btw">
                <div className="flex-daj flex-gap20">
                  <h3 className="bold-font flex-d m-all0">
                    <span>Invoice Number : {EditObject.InvoiceNumber} </span>
                  </h3>
                  <h3 className="bold-font flex-d m-all0">
                    <span> JobID : {EditObject.JobID}</span>
                  </h3>
                </div>
                <a className="close-help" onClick={() => seteditModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message mt-20 p-all0">
                <div className="grid-d fr-1111 gap-20">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Business Name
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Business Name"
                      type="text"
                      value={EditObject.CompanyName}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          CompanyName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Client Name
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Client Name"
                      type="text"
                      value={EditObject.Name}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          Name: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Client Email
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Client Email"
                      type="text"
                      value={EditObject.EmailAddress}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          EmailAddress: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Address Line 1
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Address Line 1"
                      type="text"
                      value={EditObject.AddressLine1}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          AddressLine1: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Address Line 2
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Address Line 2"
                      type="text"
                      value={EditObject.AddressLine2}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          AddressLine2: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Post Code
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Post Code"
                      type="text"
                      value={EditObject.ZipCode}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          ZipCode: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Company Number
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Company Number"
                      type="text"
                      value={EditObject.CompanyNumber}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          CompanyNumber: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      VAT Number
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="VAT Number"
                      type="text"
                      value={EditObject.VATNumber}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          VATNumber: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => SaveEditedInvoiceData()}
                  >
                    Update
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => seteditModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">
                  {confirmationModalObject.ConfirmText}
                </h3>
                <a
                  className="close-help"
                  onClick={() => {
                    setshowModal(false);
                  }}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="modal-body">
                <div className="grid-d fr-1 gap-20 mt-20">
                  {confirmationModalObject.Refund > 0 && (
                    <h6>
                      Refund Amount: £{confirmationModalObject.RemainingAmount}
                    </h6>
                  )}
                  <div className="field-input grid-d flex-gap3">
                    <div className="font-12 text-left label-color">Notes</div>
                    <textarea
                      className="input-field w-100 h-notes"
                      value={confirmationModalObject.Notes}
                      onChange={(e) =>
                        setConfirmationModalObject((prev: any) => ({
                          ...prev,
                          Notes: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="flex-daj btn-start mt-10 flex-gap10">
                    <a
                      className="flex-daj btn-primary"
                      onClick={() =>
                        updateOrderAdminData(
                          1,
                          confirmationModalObject.PID,
                          confirmationModalObject.Refund == 1
                            ? "Refund"
                            : "ManualRefund",
                          confirmationModalObject.Refund > 0
                            ? confirmationModalObject.RemainingAmount
                            : confirmationModalObject.Status,
                          confirmationModalObject.Notes,
                          "",
                          "",
                        )
                      }
                    >
                      {/* {confirmationModalObject.Text} */}
                      Yes
                    </a>
                    <a
                      className="flex-daj btn-primary"
                      onClick={() => {
                        setshowModal(false);
                      }}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderInvoice;
